var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70711 14.7071C7.31659 15.0976 6.68342 15.0976 6.2929 14.7071L0.292894 8.70711C-0.0976313 8.31658 -0.0976313 7.68342 0.292894 7.29289L6.2929 1.29289C6.68342 0.902369 7.31659 0.902369 7.70712 1.29289C8.09764 1.68342 8.09764 2.31658 7.70712 2.70711L3.41422 7H15C15.5523 7 16 7.44772 16 8C16 8.55229 15.5523 9 15 9L3.41422 9L7.70711 13.2929C8.09764 13.6834 8.09764 14.3166 7.70711 14.7071Z",
    fill: "currentColor"
  })));
}

export default SvgArrowLeft;